import { createContext, useContext } from 'react';
export const defaultFilterBarContext = {
  isFilterBar: false
};
export const FilterBarContext = /*#__PURE__*/createContext(defaultFilterBarContext);
export function useFilterBarContext() {
  const filterBarContext = useContext(FilterBarContext);
  if (!filterBarContext) {
    throw new Error('useFilterBarContext must be used within FilterBarContextProvider');
  }
  return filterBarContext;
}
export const {
  Consumer,
  Provider
} = FilterBarContext;